import { jsx as _jsx } from "react/jsx-runtime";
export const ScalePreview = ({
  scale,
  children
}) => {
  return /*#__PURE__*/_jsx("div", {
    style: {
      height: `${100 / scale}%`,
      width: `${100 / scale}%`,
      transform: `scale(${scale})`,
      transformOrigin: 'left top'
    },
    children: children
  });
};